/**
 * API配置文件
 * 统一管理所有API端点和配置
 */

// API基础配置
export const API_CONFIG = {
  // 基础URL - 支持环境变量配置
  BASE_URL: import.meta.env.VITE_API_BASE_URL || 'https://www.54cpa.cn',
  
  // 请求超时时间（毫秒）
  TIMEOUT: 10000,
  
  // 是否启用请求日志
  ENABLE_LOG: import.meta.env.DEV,
  
  // 重试配置
  RETRY: {
    enabled: true,
    maxRetries: 3,
    retryDelay: 1000, // 重试延迟（毫秒）
  },
} as const;

// API端点配置
export const API_ENDPOINTS = {
  // 产假计算相关
  MATERNITY: {
    CALCULATE: '/api/maternity-leave/calculate', // 计算产假天数
    MISCARRIAGE_RULES: '/api/maternity-leave/ref-data/miscarriage-rules', // 流产规则
  },
  
  // 津贴计算相关
  ALLOWANCE: {
    CALCULATE: '/api/maternity-allowance/calculate', // 计算津贴
  },
  
  // 支持数据相关
  SUPPORT: {
    HOLIDAYS: '/api/support/holidays', // 节假日数据
    CITIES: '/api/support/cities', // 城市列表
  },
} as const;

// HTTP状态码
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
} as const;

// 业务错误码
export const BUSINESS_CODE = {
  SUCCESS: 0,
  FAILED: -1,
  PARAM_ERROR: 1001,
  NOT_FOUND: 1004,
  SERVER_ERROR: 5000,
} as const;
